import {components, OptionProps} from 'react-select'
import {memo} from "react";

const CheckboxOption = memo((props: OptionProps<any>) => {
  return (
      <components.Option {...props}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: "pointer" }}>
              <input
                  type="checkbox"
                  checked={props.isSelected}
                  onChange={() => null}
                  style={{ pointerEvents: 'none' }}
              />
              <span>{props.label}</span>
          </div>
      </components.Option>
  )
})

export default CheckboxOption
